import { Color } from "@identic/controls";

export function convertColorToHex(entity: any): any {
  const STRING_TYPE = typeof('');
  if (typeof(entity.hex_colour) !== STRING_TYPE) {
    entity.hex_colour = `#${(<Color|null>(entity.hex_colour))?.hex}`;
  }
  return entity;
}
